import styled from 'styled-components'

import { SPACING } from '../../component-library/design/spacing/spacing.constants'
import { AutoComplete } from '../../component-library/components/autocomplete/autocomplete.component'
import { ReactComponent as BinIcon } from '../assets/bin.svg'

const BIN_ICON_WIDTH = '25px'

const StyledAutocomplete = styled(AutoComplete)`
  margin-top: ${SPACING.XS};
  width: calc(100% - ${BIN_ICON_WIDTH} - 5px);
`

const StyledBinIcon = styled(BinIcon)`
  cursor: pointer;
  position: relative;
  top: 15px;
`

const AutoCompleteWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export {
  StyledAutocomplete,
  StyledBinIcon,
  AutoCompleteWrapper,
}
